module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedMediumItalic.dbc900d.woff2";